import React, { useEffect, useRef, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { PRODUCT_NAME } from './constants';
const samplePurchases = [{
  name: 'Giulia M.',
  location: 'Milano, Italia'
}, {
  name: 'Francesca R.',
  location: 'Roma, Italia'
}, {
  name: 'Elisa B.',
  location: 'Torino, Italia'
}, {
  name: 'Martina C.',
  location: 'Bologna, Italia'
}, {
  name: 'Chiara D.',
  location: 'Napoli, Italia'
}, {
  name: 'Silvia P.',
  location: 'Firenze, Italia'
}, {
  name: 'Valentina S.',
  location: 'Padova, Italia'
}, {
  name: 'Alessia T.',
  location: 'Palermo, Italia'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(samplePurchases[0]);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    const showPopup = () => {
      setCurrent(samplePurchases[Math.floor(Math.random() * samplePurchases.length)]);
      setVisible(true);
      if (hideTimer.current) clearTimeout(hideTimer.current);
      hideTimer.current = setTimeout(() => setVisible(false), 5000);
    };
    const initialTimer = setTimeout(showPopup, 3000);
    const interval = setInterval(showPopup, 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
      if (hideTimer.current) clearTimeout(hideTimer.current);
    };
  }, []);
  return visible ? <aside className="fixed bottom-3 left-3 z-50 w-[calc(100%-1.5rem)] max-w-[260px] animate-slide-in" aria-live="polite" data-id="element-183" data-mp="2qdc1v7sc97s9">
      <div className="relative overflow-hidden rounded-xl border-2 border-brand-navy bg-brand-mint p-3 pr-8 shadow-2xl ring-2 ring-brand-gold/70" data-id="element-184" data-mp="2lfiwui2rujtk">
        <div className="absolute inset-x-0 top-0 h-1 bg-brand-gold" data-id="element-185" data-mp="2gh9228kyll8h" />
        <button type="button" onClick={() => setVisible(false)} className="absolute right-1.5 top-1.5 rounded p-0.5 text-brand-slate transition-colors hover:text-brand-ink" aria-label="Chiudi notifica di acquisto" data-id="element-186" data-mp="2cd9n3ufbuuh8">
          <XIcon className="h-3.5 w-3.5" data-id="element-187" data-mp="12f9tzpw6m08w" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-188" data-mp="12dqj6etaohei">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-brand-gold/70 bg-brand-gold/20" data-id="element-189" data-mp="17duxpzan7223">
            <ShoppingBagIcon className="h-4 w-4 text-brand-navy" data-id="element-190" data-mp="sjq35hwh5rr0" />
          </div>
          <div className="min-w-0 leading-tight" data-id="element-191" data-mp="xf5dhzv9x5io">
            <p className="font-display text-sm font-bold text-brand-ink" data-id="element-192" data-mp="jplft8gjuyg8">{current.name}</p>
            <p className="text-[11px] font-semibold text-brand-slate" data-id="element-193" data-mp="og1v6y3xku58">da {current.location}</p>
            <p className="mt-0.5 text-xs font-bold text-brand-navy" data-id="element-194" data-mp="9r5qnb131z9d">ha appena acquistato {PRODUCT_NAME}</p>
          </div>
        </div>
      </div>
    </aside> : null;
}